module.exports = __webpack_public_path__ + "images/emoji/beer.bd0111d1acdaf65e77d3.png";